/* eslint-disable react/prop-types */
import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconSbacZoomReset = (props) => (
  <SVG viewBox="2 2 19 19" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M17.01 14.26H16.21L15.94 13.99C16.92 12.85 17.51 11.38 17.51 9.76001C17.51 6.17001 14.6 3.26001 11.01 3.26001C7.42 3.26001 4.51 6.26001 4.51 9.76001H2L5.84 13.76L10 9.76001H6.51C6.51 7.26001 8.53 5.26001 11.01 5.26001C13.49 5.26001 15.51 7.27001 15.51 9.76001C15.51 12.24 13.49 14.26 11.01 14.26C10.36 14.26 9.75 14.12 9.19 13.88L7.71 15.36C8.68 15.93 9.8 16.26 11.01 16.26C12.62 16.26 14.09 15.67 15.23 14.69L15.5 14.96V15.75L20.51 20.74L22 19.26L17.01 14.26Z" />
  </SVG>
)

export default withIconStyles(IconSbacZoomReset)
